// extracted by mini-css-extract-plugin
export default {"powerBy":"power-by_powerBy__WUa-M"};